import { createContext } from "react";

// import { Users } from "generated";

export interface IAuthContext {
  isAuthenticated: boolean;
  // user?: Partial<Users> | null;
  user?:  null;
}

const AuthContext = createContext<IAuthContext>({
  user: null, isAuthenticated: false
});

export default AuthContext;
